import { Injectable } from '@angular/core';
import { IntegrationService } from './integration.service';
import { HttpClient } from '@angular/common/http';
import { HeadersService } from '../utilities/HeadersService';

@Injectable()
export class DrupalFormService {
  constructor(private http: HttpClient, private headersService: HeadersService, private integrationService: IntegrationService) {}

  createDrupalForm(name: string) {
    try {
        const url = `${this.integrationService.JfkEnv.BaseUrl}api/ria.SacContentRouter/v1/API/content?path=sac-resource/${name}`;
        const headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
        headers['Accept'] = '*/*';
        this.http.get<any>(url, {headers}).subscribe(response => {
            const title = response.Title;
            const bynderUrl = response.Uri;
            fetch(bynderUrl)
            .then(response => response.blob())
            .then(blob => {
                this.downloadPdf(blob, title);
            });
        });
    } catch {
        return;
    }
  }

  private downloadPdf(blob: Blob, name: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
  }
}